import { GraphQLClient } from "graphql-request";

export const API_URL = 'https://scandi-react-ecommerce-git-main-codeloverx.vercel.app'

export const graphQLClient = new GraphQLClient(API_URL)

